import { useState } from "react";
import { Link, useParams, useNavigate } from "react-router-dom";
import { useNotification } from "../../contexts/NotificationContext";
import { authFetch } from "../../utils/authFetch";

const AlterarSenha = () => {
    const navigate = useNavigate();
    const { showNotification } = useNotification();
    
    const { id } = useParams(); // Pegando o ID do usuário da URL    

    const [password, setPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!password || !confirmPassword) {
            showNotification("danger", "Todos os campos são obrigatórios!");
            return;
        }

        if (password !== confirmPassword) {
            showNotification("danger", "As senhas não coincidem!");
            return;
        }

        const payload = {
            id: id,
            password,
        };

        try {
            const response = await authFetch('user', {
                method: "PUT",                
                body: JSON.stringify(payload),
            });

            if (!response.ok) throw new Error("Erro ao alterar a senha!");

            showNotification("success", "Senha alterada com sucesso!");

            setTimeout(() => navigate("/"), 2000);
        } catch (error) {
            console.error("Erro:", error);
            showNotification("danger", "Erro ao alterar a senha!");
        }
    };

    return (
        <div className="card">
            <div className="card-body p-3">
                <div className="row">
                    <aside className="column">
                        <div className="side-nav">
                            <h4 className="font-weight-bolder mb-0">Alterar Senha</h4>
                        </div>
                    </aside>
                    <div className="column-responsive column-80">
                        <div className="usuarios form content">
                            <form onSubmit={handleSubmit} className="col-md-4">
                                <div className="mb-3">
                                    <label htmlFor="password" className="form-label">Nova Senha</label>
                                    <input
                                        type="password"
                                        className="form-control"
                                        id="password"
                                        value={password}
                                        onChange={(e) => setPassword(e.target.value)}
                                    />
                                </div>

                                <div className="mb-3">
                                    <label htmlFor="confirmPassword" className="form-label">Confirmar Nova Senha</label>
                                    <input
                                        type="password"
                                        className="form-control"
                                        id="confirmPassword"
                                        value={confirmPassword}
                                        onChange={(e) => setConfirmPassword(e.target.value)}
                                    />
                                </div>
                                <div className="card-footer" style={{ paddingLeft: "0" }}>
                                    <Link to="/Usuarios" className="btn btn-info btn-sm">
                                        Voltar
                                    </Link>
                                    <button type="submit" className="btn btn-primary btn-sm mx-1">Alterar Senha</button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AlterarSenha;